import React from 'react';
import { Field } from 'react-final-form';

import { useDeepEqualSelector } from 'Shared/utils/hooks';
import { WpContainer, WpContainerHeader, WpContainerBody } from 'Wpds/components/container';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';

import './FeedbackRequestSection.scss';

function FeedbackRequestSection() {
  const teammate = useDeepEqualSelector(state => {
    const workspaceMembers = state.workspace.users;
    return workspaceMembers?.find(({ id }) => id !== state.user.id);
  });

  const teammateLabel = teammate?.firstName || teammate?.email || 'teammate';

  return (
    <div className="FeedbackRequestSection">
      <WpContainer>
        <WpContainerHeader>
          <div className="FeedbackRequestSection__title">Request feedback</div>
        </WpContainerHeader>
        <WpContainerBody>
          <div className="FeedbackRequestSection__content">
            {`Would you like to request feedback from ${teammateLabel} too?`}
            <Field type="checkbox" name="isFeedbackRequested">
              {({ input: { onChange, value } }) => (
                <StyledCheckbox
                  className="FeedbackRequestSection__content__checkbox"
                  label={`Yes, request feedback from ${teammateLabel}`}
                  value={value}
                  checked={value}
                  onChange={onChange}
                />
              )}
            </Field>
          </div>
        </WpContainerBody>
      </WpContainer>
    </div>
  );
}

export default FeedbackRequestSection;
